<template>
  <calendar />
</template>

<script>
import Calendar from '@/views/calendar/components/calendar'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'CalendarView',
  components: {
    Calendar
  },
  mixins: [
    ContentMixin
  ],
  beforeRouteLeave (to, from, next) {
    this.ContentMixin_Leave(next)
  }
}
</script>
